var cov_wdvygys8 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/EditableArea/styles/index.js",
      hash = "6dff8a72c0597ea48ee8ef55ac6d70796e85285a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/EditableArea/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 33
        },
        end: {
          line: 5,
          column: 77
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var editableAreaLess = {};
import genaration from '../../utils/classname';
export var editableAreaClass = (cov_wdvygys8.s[0]++, genaration(editableAreaLess, 'editableArea'));